import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Interaction } from 'src/app/pages/interactions/interaction.model';

@Component({
  selector: 'app-statica',
  templateUrl: './statica.component.html',
  styleUrls: ['./statica.component.scss']
})
export class StaticaComponent implements OnInit {

  @Input() interaction: Interaction;
  @Output() addInteraction = new EventEmitter();

  staticaForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    subtitle: new FormControl('',),
    info: new FormControl(''),
    lat: new FormControl(''),
    lng: new FormControl(''),
    hasImage: new FormControl(false, [Validators.required]),
    image: new FormControl(null),
    description: new FormControl('', [Validators.required])
  });
  
  constructor() { }

  ngOnInit(): void {
    if (this.interaction) { // devo riempire i field
      this.populateForm();
    } else {
      this.interaction = {interactionType: 'statica'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.staticaForm.controls;
  }

  populateForm(): void {
    this.f.title.setValue(this.interaction.title);
    this.f.subtitle.setValue(this.interaction.subtitle);
    this.interaction.interactionData && this.interaction.interactionData.info ? this.f.info.setValue(this.interaction.interactionData.info) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lat.setValue(this.interaction.interactionData.coordinates.lat) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lng.setValue(this.interaction.interactionData.coordinates.lng) : '';
    if (this.interaction.image) {
      this.f.hasImage.setValue(true);
      this.f.image.setValue(this.interaction.image);
    }
    this.f.description.setValue(this.interaction.description);
  }

  setImageUrl(event): void {
    this.f.image.setValue(event ? event.filename : null);
    this.interaction.image = event ? event.filename : null;
  }

  validateTitle(): boolean {
    return !this.f.title.errors && !this.f.subtitle.errors;
  }

  setTitle(): void {
    this.interaction.title = this.f.title.value;
    if (this.f.hasImage) {
      this.interaction.image = this.f.image.value;
    }
    this.interaction.subtitle = this.f.subtitle.value;
  }

  validateContenuto(): boolean {
    let valid = true;
    if (this.f.hasImage.value) {
      if (!this.f.image.value) {
        valid = false;
      }
    }
    if (this.f.description.errors) {
      valid = false;
    }
    return valid;
  }

  onAddInteraction(): void {
    this.interaction.description = this.f.description.value;
    this.f.hasImage.value ? this.interaction.image = this.f.image.value : '';
    this.interaction.interactionData = {
      info: this.f.info.value,
      coordinates: {
        lat: this.f.lat.value,
        lng: this.f.lng.value
      }
    };
    this.addInteraction.emit(this.interaction);
  }

}
